import AudioPlayer from '@/components/audio/AudioPlayer.comp.tsx';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import VideoFull from '@/views/process/components/quizInialized/intro/segments/VideoFull.tsx';
import LottieFromUrl from '@/views/process/components/quizInialized/LottieFromUrl.tsx';
import SkipButton from '@/views/process/components/quizInialized/SkipButton.tsx';
import { FC, useEffect } from 'react';

export interface SegmentWrapperProps {
  animationUrl?: string;
  audioUrl?: string;
  content: React.ReactNode;
  disabledButton?: boolean;
  handleNext?: () => void;
  hasNext?: boolean;
  muted?: boolean;
  showSkip?: boolean;
  videoUrl?: string;
}

const SegmentWrapper: FC<SegmentWrapperProps> = ({
  animationUrl,
  audioUrl,
  content,
  disabledButton,
  handleNext,
  hasNext,
  muted,
  showSkip = false,
  videoUrl,
}) => {
  const { t } = useTranslationWithPrefix('views.process.quizScenarios');
  const isMobile = useMobileMediaQuery();

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo({ behavior: 'smooth', top: 0 });
    }, 100);
    return () => clearTimeout(timeout);
  }, [audioUrl]);

  if (isMobile) {
    return (
      <div className="flex flex-col gap-l my-1">
        {videoUrl ? (
          <VideoFull
            handleNext={handleNext}
            loop
            muted={muted}
            showSkip={showSkip}
            videoUrl={videoUrl}
          />
        ) : (
          <div className="relative">
            <LottieFromUrl animationUrl={animationUrl} autoplay={true} loop={true} />
            {showSkip && handleNext && <SkipButton onSkip={handleNext} />}
          </div>
        )}
        <div className="flex flex-column max-w-(--breakpoint-md) gap-l mb-[1rem]">
          {content}
          {hasNext && (
            <ButtonWithLoading disabled={disabledButton} onClick={handleNext}>
              {t('buttons.next')}
            </ButtonWithLoading>
          )}
        </div>
        <div className="fixed-bottom">
          <AudioPlayer audioUrl={audioUrl} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-32 items-start">
      <AudioPlayer audioUrl={audioUrl} />
      <div className="flex flex-column min-w-[300px] w-[650px] gap-l my-2">
        {content}
        {hasNext && (
          <ButtonWithLoading disabled={disabledButton} onClick={handleNext}>
            {t('buttons.next')}
          </ButtonWithLoading>
        )}
      </div>
      <div className="flex flex-column w-[400px] relative justify-content-end">
        {videoUrl ? (
          <VideoFull
            handleNext={handleNext}
            loop
            muted={muted}
            showSkip={showSkip}
            videoUrl={videoUrl}
          />
        ) : (
          <div className="relative">
            <LottieFromUrl animationUrl={animationUrl} autoplay={true} loop={true} />
            {showSkip && handleNext && <SkipButton onSkip={handleNext} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default SegmentWrapper;
